import React from 'react'
import Menu from 'components/Menu'
import MenuItem from 'components/MenuItem'
import { useWindowScrollPosition } from 'the-platform';
import './NavBar.css'
import newLogo from 'images/new-logo-2.png'

import IconButton from '@material-ui/core/IconButton'
import MenuIcon from '@material-ui/icons/Menu'

import MuiMenu from '@material-ui/core/Menu'
import MuiMenuItem from '@material-ui/core/MenuItem'

const menuItems = [
  { title: 'Home', href: '#home' },
  { title: 'Features', href: '#features' },
  { title: 'About', href: '#about' },
  { title: 'Contact Us', href: '#contact' },
]
const Navbar = () => {
  const snapHeight = 90
  const { y } = useWindowScrollPosition()

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => setAnchorEl(event.currentTarget)
  const handleClose = () => setAnchorEl(null)

  // const [currentSection, setCurrentSection] = React.useState('')
  // React.useEffect(() => {
  //   const handler = () => {
  //     setCurrentSection(window.location.hash)
  //   }
  //   handler()
  //   window.addEventListener('hashchange', handler)

  //   return () => {
  //     window.removeEventListener('hashchange', handler)
  //   }
  // }, [])

  return (
    <div className={`
      w-full
      flex items-end
      text-white fixed top-0 left-0 right-0 opacity-10 z-40
      px-1 pb-2 lg:px-32

      ${(y) > snapHeight ? 'h-20 changeStyle' : 'h-32'} 
      transition-all duration-1000 ease-in-out
    `}
    >
      <div style={{ height: '100%' }}>
        <img style={{ height: '90%',}} className='md:h-full py-2' src={newLogo} alt='ENData Claims' />
      </div>
      <div className='flex-grow' />
      <Menu className='hidden md:flex mt-auto mb-auto'>
        {menuItems.map(item => {
          //return <MenuItem key={item.href} active={currentSection === item.href} {...item} />
          return <MenuItem key={item.href} {...item} />
        })}
      </Menu>
      
      <div className="md:hidden py-1">
        <IconButton  color='inherit' onClick={handleClick}>
          <MenuIcon />
        </IconButton>
        <MuiMenu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          getContentAnchorEl={null}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
        >
          {menuItems.map(item => (
            <MuiMenuItem onClick={handleClose} component='a' key={item.href} href={item.href}>
              {item.title}
            </MuiMenuItem>
          ))}
        </MuiMenu>
      </div>
    </div>
  )
}
export default Navbar
